// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 466) return "static/chunks/466-6c11161946d47168.js";
	if (chunkId === 218) return "static/chunks/218-895ea19ddbdde669.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"352":"9138c3ad0d51f399","408":"5a7cde36d91bd4e3"}[chunkId] + ".js";
};